import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {ProgressBarLoaderComponent} from '../common/progress-bar-loader/progress-bar-loader.component';
import { FormsModule } from '@angular/forms';
import { HttpService } from '../services/http.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LinkInputPopupComponent } from '../common/popups/link-input-popup/link-input-popup.component';
import { FileUploadPopupComponent } from '../common/popups/file-upload-popup/file-upload-popup.component';
import { LinksDialogComponent } from '../links-dialog/links-dialog.component';
import { ValidityScoreComponent } from "../common/validity-score/validity-score.component";
import { DataService } from '../services/data.service';
import { AppConstants } from '../../constants/app.constants';
import { InvalidityDashboardComponent } from "../sniff-invalidity-report/invalidity-dashboard.component";
import { SniffReportComponent } from "../sniff-report/sniff-report.component";
import { ScoreLegendComponent } from "../common/score-legend/score-legend.component";
import { PopoverClose, PopoverComponent, PopoverTemplate } from '@ngx-popovers/popover';

@Component({
  selector: 'app-prior-art-search',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, FormsModule, HttpClientModule, ProgressBarLoaderComponent, ValidityScoreComponent, InvalidityDashboardComponent, SniffReportComponent, ScoreLegendComponent,PopoverClose, PopoverComponent, PopoverTemplate],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './prior-art-search.component.html',
  styleUrls: ['./prior-art-search.component.css']
})
export class PriorArtSearchComponent implements OnInit {
  isLoading: boolean = false;
  @Input() patentData: any = [
    {
      patentNumber: 'US8373135B2',
      currentAssignee: 'Samsung Electronics Co. Ltd.',  
    }
  ];
  @Input() updateData:any;
  @Input() updateRoute:any;

  invaliditySearchOnly=false;
  constructor(private http: HttpService, public dialog: MatDialog, public dataService: DataService, private router: Router) {

    this.patentData= this.dataService.inputData;
    this.updateData=this.dataService.updateDataSameStructure.bind(this.dataService);
    this.updateRoute=this.dataService.updateRouteObservable.bind(this.dataService);
    this.invaliditySearchOnly=this.dataService.invalidityOnly;
  }



  currentStage: number = 2;
  loadingText: string = 'Loading, please wait';
  titleText: string = 'Reference Links';
  patentDetails: any[] = [];
  mock: boolean = false; // Set this to true for mock responses
  isEditingCompanies: boolean = false;
  isEditingProducts: boolean = false;

  networkError: boolean = false;

  showSearchStrings=false;
  patentReferenceTierMap:any={}

  keywordItems:any=[]

  searchStringMap:any={}

  claimsConsideredMap:any={}

  summaryData:any=[]

  referenceTableMap:any={
    // "US20190000001":[{
    //   referenceTitle:"US10659731B2",
    //   claims:[{
    //     claim_element: "- A counting detector  ",
    //     mapping:"Full Overlap",
    //     ai_comment:"The claim element 'A counting detector' is explicitly supported by multiple references to the Photon Counting Detector (PCD) technology utilized in the OmniTom Elite CT scanner. These references describe the functionality and capabilities of the PCD, emphasizing its role in capturing CT data and generating spectral images, which aligns directly with the concept of a counting detector.",
    //     validity_score:""
    //   }]
    // },{
    //   referenceTitle:"US10659731B2",
    //   claims:[{
    //     claim_element: "- A counting detector  ",
    //     mapping:"Full Overlap",
    //     ai_comment:"The claim element 'A counting detector' is explicitly supported by multiple references to the Photon Counting Detector (PCD) technology utilized in the OmniTom Elite CT scanner. These references describe the functionality and capabilities of the PCD, emphasizing its role in capturing CT data and generating spectral images, which aligns directly with the concept of a counting detector.",
    //     validity_score:""
    //   }]
    // }],
    // "US20190000002":[{
    //   referenceTitle:"US10659731B2",
    //   claims:[{
    //     claim_element: "- A counting detector  ",
    //     mapping:"Partial Overlap",
    //     ai_comment:"The claim element 'A counting detector' is explicitly supported by multiple references to the Photon Counting Detector (PCD) technology utilized in the OmniTom Elite CT scanner. These references describe the functionality and capabilities of the PCD, emphasizing its role in capturing CT data and generating spectral images, which aligns directly with the concept of a counting detector.",
    //     validity_score:""
    //   }]
    // }],
  }
  referenceTableOpenMapObj:any={}


  ngOnInit(): void {
    this.patentDetails=this.patentData;
    // this.getTargetLinks();
    // this.makePASApiCall();
    let invalidityData=this.dataService.pasData;
    console.log('invalidityData:', invalidityData);
    /*{
          referenceTableMap:this.referenceTableMap,
          summaryData:this.summaryData,
          claimsConsideredMap:this.claimsConsideredMap,
          patentReferenceTierMap:this.patentReferenceTierMap,
          keywordItems:this.keywordItems
        }

        reverse parse this object
          */
        if(invalidityData!=null && invalidityData!=undefined&&Object.keys(invalidityData).length>0
      && invalidityData.hasOwnProperty('referenceTableMap')&&invalidityData.hasOwnProperty('summaryData')&&invalidityData.hasOwnProperty('claimsConsideredMap')&&invalidityData.hasOwnProperty('patentReferenceTierMap')&&invalidityData.hasOwnProperty('keywordItems')&&invalidityData.referenceTableMap!=null&&invalidityData.summaryData!=null&&invalidityData.claimsConsideredMap!=null&&invalidityData.patentReferenceTierMap!=null&&invalidityData.keywordItems!=null
      ){
    this.referenceTableMap=invalidityData.referenceTableMap;
    this.summaryData=invalidityData.summaryData;
    this.claimsConsideredMap=invalidityData.claimsConsideredMap;
    this.patentReferenceTierMap=invalidityData.patentReferenceTierMap;
    this.keywordItems=invalidityData.keywordItems;

    this.currentStage = 4;
    this.titleText="Summary"
    this.dataService.updateHasPasReportObservable(true);
        }
        else{

          this.pasFirstApiCall();
          this.apiProgress=0;
        }
        if(this.router.url.includes('pas/report')){
          this.currentStage=5;
          // find query params using url
          const queryParams = new URLSearchParams(this.router.url.split('?')[1]);
          this.selectedPatentIndex = queryParams.get('patentIndex');
          console.log('selectedPatentIndex', this.selectedPatentIndex);
          
        }
  }

  companySelectionList:any=[];
  productSelectionList:any=[];
  claimChartData:any= []
  patentInfringementScoreData:any={}
  referenceDivOpenMapObj:any={};

  makePASApiCall(){
    this.isLoading = true;
    this.loadingText = 'Retrieving Patent Details, please wait';
    if(this.mock){
      
    }
    else{
      let requests=this.patentData.map((patent:any)=>this.http.post('/prior_art_search/get_patent_references/', {patentNumber:patent.patentNumber}));
      let index=0;
      Promise.all(requests).then(responses=>{
        responses.forEach((response:any)=>{
          console.log(response);
          // References for stage 2
          Object.keys(response['References data']['Filtered References']).forEach((patentNumber:any)=>{
          if(!this.patentReferenceTierMap[patentNumber]){
              this.patentReferenceTierMap[patentNumber]=[];
            }
            Object.keys(response['References data']['Filtered References'][patentNumber]).forEach((referencePatentNumber:any)=>{
              let tier=parseInt(response['References data']['Filtered References'][patentNumber][referencePatentNumber].replace('T',''));
              this.patentReferenceTierMap[patentNumber].push({patentNumber:referencePatentNumber, tier:tier});
              this.patentReferenceTierMap[patentNumber].sort((a:any,b:any)=>{
                console.log('a:',a);
                console.log('b:',b);
                return a.tier<b.tier;
              });
            });
          
          });
          // search strings for stage 2
          response.Reference.forEach((reference:any)=>{
            this.keywordItems.push(reference['Search Strings']);
          });
          //  claims considered for future usage
          this.claimsConsideredMap[response['References data']['Patent Number']]=response['References data']['Claim considered for analysis'];
          // claim summary map
          response['prior art report'].forEach((report:any)=>{
            this.summaryData.push({
              patentNumber:report['Parent Patent'],
              title:report['Title'],
              assignee:report['Assignee'],
              score:report['Score']
            });
          });
          // actual claim chart mapping
          /*"data": {
    "US10579372B1 vs CN107209861B": "{\"Claim elements of Parent Patent\":{\"0\":\"- A method of machine learning using application programming interface (API) documentation, the method comprising:\",\"1\":\"- receiving a first API documentation that includes a first endpoint and metadata that corresponds to the first endpoint, wherein the metadata includes at least one of a header, a page title, and a sentence that correspond to the first endpoint;\",\"2\":\"- receiving a verified API specification that includes a verified endpoint;\",\"3\":\"- comparing the first endpoint to the verified endpoint;\",\"4\":\"- classifying the metadata by:\",\"5\":\"- responsive to the first endpoint being the same as the verified endpoint, classifying the metadata as a positive item; or\",\"6\":\"- responsive to the first endpoint not being the same as the verified endpoint, classifying the metadata as a negative item;\",\"7\":\"- generating a training dataset including the metadata classified as a positive item or a negative item; and\",\"8\":\"- generating a metadata model using a machine learning algorithm and the training dataset, the metadata model configured to be used to determine whether an unknown endpoint is a positive endpoint based on corresponding metadata.\"},\"Mapping of claim element with Child patent\":{\"0\":50,\"1\":0,\"2\":0,\"3\":0,\"4\":0,\"5\":50,\"6\":50,\"7\":50,\"8\":50},\"AI Comment\":{\"0\":\"There is partial overlap between the parent patent's claim element and the child patent's claims. Both patents discuss methods involving machine learning, but the child patent focuses on multimedia data items rather than API documentation specifically. The concepts of extracting features and training classifiers are present in both, indicating some commonality in the machine learning aspect.\",\"1\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The parent patent focuses on API documentation, endpoints, and metadata, while the child patent describes a method related to multimedia data items and classifiers without any mention of APIs or related metadata.\",\"2\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The child patent focuses on multimedia data and classifiers, while the parent patent relates to API specifications and endpoints.\",\"3\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The child patent focuses on multimedia data items and classifiers, while the parent patent discusses comparing API endpoints.\",\"4\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The parent patent discusses classifying metadata related to API documentation, while the child patent focuses on a method for processing multimedia data items without any mention of metadata classification.\",\"5\":\"There is partial overlap as both the parent and child patents involve classification of data based on comparisons (specifically endpoints). However, the child patent focuses on multimedia data items and their classification, which is a different context than the metadata classification based on API endpoints in the parent patent.\",\"6\":\"There is partial overlap. The parent patent discusses classifying metadata as a negative item based on comparison of endpoints, which aligns with the child patent's focus on classification and similarity assessment. However, the child patent does not explicitly mention endpoints or metadata classification in the same context, leading to a score of 50 for partial overlap.\",\"7\":\"There is partial overlap between the parent patent and the child patent. Both patents involve the generation of datasets and classification of items (positive and negative). However, the child patent focuses on multimedia data items and classifiers, which is a different context from the metadata-based API attribute extraction described in the parent patent.\",\"8\":\"There is partial overlap between the claim element from the parent patent and the child patent's claims. Both patents involve the use of machine learning algorithms and models to classify or determine the status of data items (endpoints in the parent patent, multimedia data items in the child patent). However, the specific context and application differ, as the child patent focuses on multimedia data items and labeling rather than metadata models specifically for endpoints.\"}}",
    "US10579372B1 vs CN102549603B": "{\"Claim elements of Parent Patent\":{\"0\":\"- A method of machine learning using application programming interface (API) documentation, the method comprising:\",\"1\":\"- receiving a first API documentation that includes a first endpoint and metadata that corresponds to the first endpoint, wherein the metadata includes at least one of a header, a page title, and a sentence that correspond to the first endpoint;\",\"2\":\"- receiving a verified API specification that includes a verified endpoint;\",\"3\":\"- comparing the first endpoint to the verified endpoint;\",\"4\":\"- classifying the metadata by:\",\"5\":\"- responsive to the first endpoint being the same as the verified endpoint, classifying the metadata as a positive item; or\",\"6\":\"- responsive to the first endpoint not being the same as the verified endpoint, classifying the metadata as a negative item;\",\"7\":\"- generating a training dataset including the metadata classified as a positive item or a negative item; and\",\"8\":\"- generating a metadata model using a machine learning algorithm and the training dataset, the metadata model configured to be used to determine whether an unknown endpoint is a positive endpoint based on corresponding metadata.\"},\"Mapping of claim element with Child patent\":{\"0\":50,\"1\":0,\"2\":0,\"3\":0,\"4\":0,\"5\":0,\"6\":0,\"7\":50,\"8\":0},\"AI Comment\":{\"0\":\"There is partial overlap as both patents involve methods of machine learning. However, the parent patent specifically focuses on machine learning using API documentation, while the child patent pertains to creating a searchable video index without any reference to API documentation. Thus, the core concepts are related, but the specific applications and contexts differ.\",\"1\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The child patent focuses on video indexing and machine learning related to audio-visual content, while the parent patent relates to API documentation and metadata extraction, which are not addressed in the child patent.\",\"2\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The child patent focuses on methods related to creating searchable video indexes and does not mention APIs or verified endpoints.\",\"3\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The child patent focuses on methods related to creating searchable video indexes and does not mention endpoints or comparisons related to API specifications.\",\"4\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The child patent focuses on video indexing and machine learning related to audio-visual content without any mention of metadata classification.\",\"5\":\"There is no overlap between the claim element from the parent patent and the descriptions or claims in the child patent. The child patent focuses on creating a searchable video index and does not discuss endpoints or metadata classification related to API specifications as described in the parent patent.\",\"6\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The child patent focuses on creating searchable video indexes and does not address endpoints or metadata classification related to API specifications.\",\"7\":\"There is partial overlap as both the parent patent and child patent involve the generation of datasets and relate to machine learning. However, the child patent focuses on creating a searchable video index and does not explicitly mention generating a training dataset from classified metadata as described in the parent patent.\",\"8\":\"There is no overlap between the claim element from the parent patent and the child patent's description and claims. The child patent focuses on creating a searchable video index using audio-visual content and keywords, which does not relate to generating a metadata model or determining endpoints based on metadata.\"}}"
  },*/  
          Object.keys(response.data).forEach((key:any)=>{
            let currentPatentNumber=key.split(' vs ')[0];
            let referencePatentNumber=key.split(' vs ')[1];
            let claimChartAr=[]
            let claimChartMap=JSON.parse(response.data[key]);
            // map in a datastructure similar to referenceTAbleMap
            let claimJSON:any={};
            claimJSON.referenceTitle=referencePatentNumber;
            claimJSON.claimElements=[];
            let ind=0;
            for (let aiComment in claimChartMap['AI Comment']){
             let obj:any={}
             obj['claim_element']=claimChartMap['Claim elements of Parent Patent'][ind];
              obj['ai_comment']=claimChartMap['AI Comment'][aiComment];
              let overlapNumber=claimChartMap['Mapping of claim element with Child patent'][ind];
              // convert this overlap number to a string. if it's 0, then make it 'No Overlap', if 100 make it 'Full Overlap', otherwise 'Partial Overlap'
              obj['overlap']=overlapNumber==0?'No Overlap':overlapNumber==100?'Full Overlap':'Partial Overlap';
              // obj['overlap']=claimChartMap['Mapping of claim element with Child patent'][ind];
              claimJSON.claimElements.push(obj);
              ind++;
            }
            if(!this.referenceTableMap[currentPatentNumber]){
              this.referenceTableMap[currentPatentNumber]=[];
            }
            this.referenceTableMap[currentPatentNumber].push(claimJSON);
          });
        });
        console.log('Reference Table Map:', this.referenceTableMap);
        console.log('Summary Data:', this.summaryData);
        console.log('Claims Considered Map:', this.claimsConsideredMap);
        console.log('Patent Reference Tier Map:', this.patentReferenceTierMap);
        console.log('Keyword Items:', this.keywordItems);

        
        this.isLoading = false;
        this.currentStage=2;
      }).catch(error=>{
        console.error('Error fetching patent details:', error);
        this.networkError=true;
        // this.isLoading = false;
      });
    }
  }
  patentAPIDataMap:any={}
  apiProgress=0;
  optimizeSwitch=false;

  overrideEtaValue:any=null;
  async optimizeFlow() {
    this.currentStage=2;
    this.optimizeSwitch=true;
  }
  

  async pasFirstApiCall(includeKeywordItems=false){
    this.apiProgress=0;
    this.isLoading = true;
    this.loadingText = 'Retrieving Patent References, please wait';
    let progressUpdate=33.3333/this.patentData.length;
    let calculatedEta=await this.calculateETA();
    this.overrideEtaValue=calculatedEta;
    let tempKeyword=[...this.keywordItems];
    console.log('keyword items', this.keywordItems)
    if(this.mock){
      
    }
    else{
      const makeApiCall = (patent: any, index:any) => {
        console.log('keyword items', this.keywordItems,this.keywordItems[index])
        let keyWordData= tempKeyword[index] || tempKeyword;
        if(keyWordData && keyWordData.length>0){
          keyWordData=keyWordData.split(',').map((item:any)=>item.trim());
        }
        else 
        keyWordData=undefined


        let requestBody={
          patentNumber: patent.patentNumber,
          user_search_strings:keyWordData||undefined,
        }
        return this.http.post('/prior_art_search/get_pas_references/', requestBody)
          .then((response: any) => {
        console.log(response);
        this.patentAPIDataMap[patent.patentNumber] = response;
        this.apiProgress+=progressUpdate;
        response.References.forEach((reference: any) => {
          // remove first item from keyword items if it exists
          if(this.keywordItems.length>0&&includeKeywordItems)
          {
            this.keywordItems.shift();
          }
          this.keywordItems.push(reference['Search Strings'].join(', '));

        });
        if (response.data) {
          Object.keys(response.data).forEach((key: any) => {
            let currentPatentNumber = key.split(' vs ')[0];
            let referencePatentNumber = key.split(' vs ')[1];
            let claimChartMap = JSON.parse(response.data[key]);
            let claimJSON: any = {};
            claimJSON.referenceTitle = referencePatentNumber;
            claimJSON.claimElements = [];
            let ind = 0;
            for (let aiComment in claimChartMap['AI Comment']) {
          let obj: any = {};
          obj['claim_element'] = claimChartMap['Claim elements of Parent Patent'][ind];
          obj['ai_comment'] = claimChartMap['AI Comment'][aiComment];
          let overlapNumber = claimChartMap['Mapping of claim element with Child patent'][ind];
          obj['overlap'] = overlapNumber == 0 ? 'No Overlap' : overlapNumber == 100 ? 'Full Overlap' : 'Partial Overlap';
          claimJSON.claimElements.push(obj);
          ind++;
            }
            if (!this.referenceTableMap[currentPatentNumber]) {
          this.referenceTableMap[currentPatentNumber] = [];
            }
            this.referenceTableMap[currentPatentNumber].push(claimJSON);
          });
        }
          })
          .catch((error: any) => {
        console.error('Error fetching patent details:', error);
        this.networkError = true;
          });
      };

      const executeSequentially = async () => {
        // this.keywordItems=[]; // reset keyword items

        const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
        const batchSize = 5;
        const batches = Math.ceil(this.patentData.length / batchSize);

        for (let i = 0; i < batches; i++) {
          const batchStart = i * batchSize;
          const batchEnd = Math.min(batchStart + batchSize, this.patentData.length);
          const batch = this.patentData.slice(batchStart, batchEnd);

          const promises = batch.map((patent:any, index:any) => makeApiCall(patent, index));
          await Promise.all(promises);
          await delay(3000);
        }
      };
      this.isLoading = true;
      this.loadingText = 'Retrieving Patent Details, please wait';
      executeSequentially().then(() => {
        console.log('Reference Table Map:', this.referenceTableMap);
        console.log('Summary Data:', this.summaryData);
        console.log('Claims Considered Map:', this.claimsConsideredMap);
        console.log('Patent Reference Tier Map:', this.patentReferenceTierMap);
        console.log('Keyword Items:', this.keywordItems);
        // this.isLoading = false;
        // this.currentStage = 2;
        this.pasSecondApiCall();
      })
      .catch(error=>{
        console.error('Error fetching patent details:', error);
        this.networkError = true;
        this.dataService.handleWorkflowError();
        // this.isLoading = false;
      });
    }
  }

  pasSecondApiCall(){
    this.isLoading = true;
    this.loadingText = 'Retrieving Patent Reference Tiers, please wait';
    let progressUpdate=33.3333/this.patentData.length;
    if(this.mock){
      
    }
    else{
      const makeApiCall = (patent: any) => {
        return this.http.post('/prior_art_search/get_reference_tiers/', { patentNumber: patent.patentNumber, data: this.patentAPIDataMap[patent.patentNumber]['References dictionary'] })
          .then((response: any) => {
        console.log(response);
        this.apiProgress+=progressUpdate;
        this.patentAPIDataMap[patent.patentNumber] = { ...this.patentAPIDataMap[patent.patentNumber], ...response };
          })
          .catch((error: any) => {
        console.error('Error fetching patent details:', error);
        this.networkError = true;
          });
      };

      const executeSequentially = async () => {
        const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
        const batchSize = 5;
        const batches = Math.ceil(this.patentData.length / batchSize);

        for (let i = 0; i < batches; i++) {
          const batchStart = i * batchSize;
          const batchEnd = Math.min(batchStart + batchSize, this.patentData.length);
          const batch = this.patentData.slice(batchStart, batchEnd);

          const promises = batch.map((patent:any) => makeApiCall(patent));
          await Promise.all(promises);
          await delay(3000);
        }
      };

      executeSequentially().then(() => {
        console.log('Reference Table Map:', this.referenceTableMap);
        console.log('Summary Data:', this.summaryData);
        console.log('Claims Considered Map:', this.claimsConsideredMap);
        console.log('Patent Reference Tier Map:', this.patentReferenceTierMap);
        console.log('Keyword Items:', this.keywordItems);
        this.pasThirdApiCall();
      })
      .catch(error=>{
        console.error('Error fetching patent details:', error);
        this.networkError = true;
        this.dataService.handleWorkflowError();
        // this.isLoading = false;
      });
    }
  }

  pasThirdApiCall(){
    this.isLoading = true;
    this.loadingText = 'Preparing Claim Feature Matrix, please wait';
    let progressUpdate=33.3333/this.patentData.length;
    if(this.mock){
      
    }
    else{
      const makeApiCall = (patent: any) => {
        return this.http.post('/prior_art_search/get_claim_feature/', { patentNumber: patent.patentNumber, filtered_dict: this.patentAPIDataMap[patent.patentNumber].filtered_dict, similarity_results: this.patentAPIDataMap[patent.patentNumber].similarity_results })
          .then((response: any) => {
        console.log(response);
        this.apiProgress+=progressUpdate;
        let selectedReferences = response['References Data']['Selected References'][Object.keys(response['References Data']['Selected References'])[0]];

        Object.keys(response['References Data']['Selected References']).forEach((patentNumber: any) => {
          if (!this.patentReferenceTierMap[patentNumber]) {
            this.patentReferenceTierMap[patentNumber] = [];
          }
          Object.keys(response['References Data']['Selected References'][patentNumber]).forEach((referencePatentNumber: any) => {
            let tier = parseInt(response['References Data']['Selected References'][patentNumber][referencePatentNumber].similarity_tier.replace('T', ''));
            let description = selectedReferences[referencePatentNumber].child_description;
            console.log('Description:', description);
            console.log(selectedReferences[referencePatentNumber]);
            this.patentReferenceTierMap[patentNumber].push({ patentNumber: referencePatentNumber, tier: tier, description: description });
          });
          this.patentReferenceTierMap[patentNumber].sort((a: any, b: any) => {
            console.log('a: ', a, 'b: ', b);
            console.log(a.tier, b.tier)
            return a.tier - b.tier;
          });

        });

        this.claimsConsideredMap[response['References Data']['Patent Number']] = response['References Data']['Claim considered for analysis'];

        response['prior art report'].forEach((report: any) => {
          this.summaryData.push({
            patentNumber: report['Parent Patent'],
            title: report['Title'],
            assignee: report['Assignee'],
            score: Math.ceil(report['Score'] / 10)
          });
        });

        Object.keys(response.data).forEach((key: any) => {
          
          let currentPatentNumber = key.split(' vs ')[0];
          let referencePatentNumber = key.split(' vs ')[1];
          let claimChartMap = JSON.parse(response.data[key]);
          let claimJSON: any = {};
          claimJSON.referenceTitle = referencePatentNumber;
          claimJSON.claimElements = [];
          let ind = 0;
          for (let aiComment in claimChartMap['AI Comment']) {
            let obj: any = {};
            obj['claim_element'] = claimChartMap['Claim elements of Parent Patent'][ind];
            obj['ai_comment'] = claimChartMap['AI Comment'][aiComment];
            let overlapNumber = claimChartMap['Mapping of claim element with Child patent'][ind];
            obj['score'] = claimChartMap['Validity Score'][ind];
            obj['score'] = Math.ceil(obj['score'] / 10);
            obj['overlap'] = overlapNumber == 0 ? 'No Overlap' : overlapNumber == 100 ? 'Full Overlap' : 'Partial Overlap';
            claimJSON.claimElements.push(obj);
            ind++;
          }
          if (!this.referenceTableMap[currentPatentNumber]) {
            this.referenceTableMap[currentPatentNumber] = [];
          }
          this.referenceTableMap[currentPatentNumber].push(claimJSON);
        });
          })
          .catch((error: any) => {
        console.error('Error fetching patent details:', error);
        this.networkError = true;
          });
      };

      const executeSequentially = async () => {
        const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
        const batchSize = 5;
        const batches = Math.ceil(this.patentData.length / batchSize);

        for (let i = 0; i < batches; i++) {
          const batchStart = i * batchSize;
          const batchEnd = Math.min(batchStart + batchSize, this.patentData.length);
          const batch = this.patentData.slice(batchStart, batchEnd);

          const promises = batch.map((patent:any) => makeApiCall(patent));
          await Promise.all(promises);
          await delay(3000);
        }
      };
      executeSequentially().then(() => {
        console.log('Reference Table Map:', this.referenceTableMap);
        console.log('Summary Data:', this.summaryData);
        console.log('Claims Considered Map:', this.claimsConsideredMap);
        console.log('Patent Reference Tier Map:', this.patentReferenceTierMap);
        console.log('Keyword Items:', this.keywordItems);
        if(this.networkError){
          this.dataService.handleWorkflowError();
          return;
        }
        this.isLoading = false;
        this.currentStage = 4;
        this.titleText="Summary"
        this.updateData({
          referenceTableMap:this.referenceTableMap,
          summaryData:this.summaryData,
          claimsConsideredMap:this.claimsConsideredMap,
          patentReferenceTierMap:this.patentReferenceTierMap,
          keywordItems:this.keywordItems
        },'pas',false );
        this.saveReportData();

        this.dataService.updateHasPasReportObservable(true);
      })
      .catch((error: any) => {
        console.error('Error in executeSequentially:', error);
        this.networkError = true;
        this.dataService.handleWorkflowError();
        this.isLoading = false;
      });
    }
  }
  
saveReportData(){
  // this.loadingLink=true;
  console.log('save report clicked')
  let data:any={}
  let reportName:any=''
  reportName=this.dataService.candidateWorkflowName;
  // alert('Report Name: '+reportName)
  if(reportName==null){
    return;
  }
  let projectId=this.dataService.candidateProjectId;
  if(!projectId){
    return;
  }
  
  let reportAlreadySaved;
  reportAlreadySaved=window.sessionStorage.getItem('reportAlreadySaved');
  if(reportAlreadySaved=='true'){
    // this.loadingLink=false;
    return;
  }
  this.dataService.workflowProgressStatus='done';
  
  this.dataService.syncWorkflow((res:any)=>{
    let reportId=res.workflowId;
    window.sessionStorage.setItem('reportAlreadySaved', 'true');
    window.sessionStorage.setItem('reportId', reportId); 
    // this.fetchShareableLink();
    // this.shareCalled=true;
  })
}


  async calculateETA(){
    let api1 = '/prior_art_search/get_pas_references/';
    let api2 = '/prior_art_search/get_reference_tiers/';
    let api3 = '/prior_art_search/get_reference_tiers/';

    let apiList = [api1, api2, api3];

    let serverUrl = AppConstants.SERVER_CONFIG.URL;

    apiList = apiList.map((api: any) => serverUrl + api);

    let etaArray: any[] = [];

    const calculateEtaForApi = async (api: string) => {
      const apiDetails = {
      api_name: api,
      request_size: 0,
      response_size: 0,
      eta: 0,
      };

      let existingDetails = {
      api_name: api,
      request_size: 0,
      response_size: 0,
      eta: 0,
      number_of_saves: 0,
      };

      const response = await this.callCalculateTimeApi(apiDetails);
      let eta = response?.eta ?? 0;
      existingDetails = { ...existingDetails, ...response };
      etaArray.push(eta);
    };

    await Promise.all(apiList.map(api => calculateEtaForApi(api)));

    let sum = etaArray.reduce((acc, eta) => acc + eta, 0);
    sum *= this.patentData.length;
    sum*=2.1;
    return sum;
    


  }
  async callCalculateTimeApi(apiDetails: any): Promise<any> {
    const calculateTimeApiUrl = '/api-metrics/calculate-time';
    try {
      const response = await this.http.post(calculateTimeApiUrl, apiDetails);
      return response
    } catch (error) {
      console.error('Error calling calculate-time API:', error);
      return null;
    }
  }
  
  


  onFinalNext(){
    this.updateData({
      referenceTableMap:this.referenceTableMap,
      summaryData:this.summaryData,
      claimsConsideredMap:this.claimsConsideredMap,
      patentReferenceTierMap:this.patentReferenceTierMap,
      keywordItems:this.keywordItems
    },'pas',false );
    this.dataService.updateHasPasReportObservable(true);
    
    this.updateRoute('target-scouting')
  }
  minStep=2;
  goBack(){
    if(this.currentStage>this.minStep)
    {

      if(this.currentStage==2&&this.optimizeSwitch){
        this.currentStage=4;
        this.titleText="Summary";
        this.optimizeSwitch=false;
      }
      else
      this.currentStage--;
    if(this.currentStage==2){
      this.titleText="Reference Links";
    }
    if(this.currentStage==3){
      this.titleText="Claim Feature Matrix";
    }
    if(this.currentStage==4){
      this.titleText="Summary";
    }
  }

    else{
      window.history.back();
    }
  }

  selectedPatentIndex:any=null

  /**
 * goToDashboard()
 * Switches to the Dashboard stage (stage 5).
 */
goToDashboard() {
  this.selectedPatentIndex=null;
  this.currentStage = 5;
  this.router.navigate(['app','pas','report'], {queryParams:{patentIndex:this.selectedPatentIndex}});

}

onReportClickCancel(){
  this.currentStage=4;  
  this.router.navigate(['app','pas'], {queryParams:{patentIndex:this.selectedPatentIndex}});


  this.selectedPatentIndex=null;
}

/**
 * getInvalidityStats()
 * Computes summary statistics from the summaryData array.
 * It calculates the total number of patents, and counts how many fall into low (score 1–3),
 * medium (score 4–6), and high (score 7–10) invalidity ranges.
 */
getInvalidityStats() {
  let total = this.summaryData.length;
  let lowCount = 0;   // Score 1-3
  let midCount = 0;   // Score 4-6
  let highCount = 0;  // Score 7-10

  this.summaryData.forEach((p: any) => {
    const s = p.score || 0;
    if (s > 0 && s <= 3) lowCount++;
    else if (s >= 4 && s <= 6) midCount++;
    else if (s >= 7) highCount++;
  });

  return { total, lowCount, midCount, highCount };
}

/**
 * viewReportForPatent(index: number)
 * Triggered when a user clicks "View Report" in the dashboard table.
 * This function sets the selected patent index so that you can show
 * detailed information (for example, by switching to a summary or detailed view).
 */
viewReportForPatent(index: number) {
  this.selectedPatentIndex = index;

  this.currentStage=5;
  // this.goToDashboard();
  // Optionally, you can change the stage (e.g., back to stage 4) to display details.
  // Example: this.currentStage = 4;
}


  onClickCancel(){
    // this.dataService.onClickCancel.bind(this.dataService)();
    this.router.navigate(['app','projects', this.dataService.candidateProjectId, 'reports'])

  }
  
  proceedToClaimFeatureMatrix(){
    this.titleText="Claim Feature Matrix";
    this.currentStage=3;
  }

  proceedToSummary(){
    this.titleText="Summary";
    this.currentStage=4;
  }

  toggleSearchStrings(){
    this.showSearchStrings=!this.showSearchStrings;
  }

  referenceDivOpenMap(patentNumber:any, index:any){
    if(!this.referenceDivOpenMapObj[patentNumber]){
      if(index==0&&this.referenceDivOpenMapObj[patentNumber]===undefined){
        this.referenceDivOpenMapObj[patentNumber]=true;
      }
      else
      this.referenceDivOpenMapObj[patentNumber]=false;
    }
    else{
      this.referenceDivOpenMapObj[patentNumber]=true;
    }
    return this.referenceDivOpenMapObj[patentNumber];
  }

  referenceTableOpenMap(patentNumber:any, referenceNumber:any, index:any){
    // map based on patentNumber and further referenceNumber. If the reference Object does not exist, create a new object with the referenceNumber as key and value as false
    if(!this.referenceTableOpenMapObj[patentNumber]){
      if(index==0&&this.referenceTableOpenMapObj[patentNumber]===undefined){
        this.referenceTableOpenMapObj[patentNumber]={};
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else
      this.referenceTableOpenMapObj[patentNumber]={};
    }
    else{
      if(!this.referenceTableOpenMapObj[patentNumber][referenceNumber]){
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else{
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
      }
    }
    return this.referenceTableOpenMapObj[patentNumber][referenceNumber];
  }

  
  get allExpanded(){
    // check if all references are expanded in the referenceTableOpenMapObj
    for(let patentNumber in this.referenceTableOpenMapObj){
      for(let referenceNumber in this.referenceTableOpenMapObj[patentNumber]){
        if(!this.referenceTableOpenMapObj[patentNumber][referenceNumber]){
          return false;
        }
      }
    }
    return true;
  }

  expandAllReferences() {
    // expand all inside referencetable map. you would need to get all reference numbers for each patent number and set them to true. the object won't have all the keys by default, so you need to create them if they don't exist. you need to toggle between true and false if all references are already expanded
    if(this.allExpanded){
      // collapse all
      for(let patentNumber in this.referenceTableOpenMapObj){
        for(let referenceNumber in this.referenceTableOpenMapObj[patentNumber]){
          this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
        }
      }
    }
    else{
      // expand all
      for(let patentNumber in this.referenceTableOpenMapObj){
        for(let referenceNumber in this.referenceTableOpenMapObj[patentNumber]){
          this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
        }
      }
    }
  }

  toggleReferenceTable(patentNumber:any, referenceNumber:any){
    if(!this.referenceTableOpenMapObj[patentNumber]){
      this.referenceTableOpenMapObj[patentNumber]={};
      this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
    }
    else{
      if(!this.referenceTableOpenMapObj[patentNumber][referenceNumber]){
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else{
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
      }
    }
  }

  get allExpandedReferenceDiv(){
    // check if all references are expanded in the referenceDivOpenMapObj
    for(let patentNumber in this.referenceDivOpenMapObj){
      if(!this.referenceDivOpenMapObj[patentNumber]){
        return false;
      }
    }
    return true;
  }

  expandAllReferenceDivs() {
    // expand all inside referenceDivOpenMapObj. you would need to get all patent numbers and set them to true. the object won't have all the keys by default, so you need to create them if they don't exist. you need to toggle between true and false if all references are already expanded
    if(this.allExpandedReferenceDiv){
      // collapse all
      for(let patentNumber in this.referenceDivOpenMapObj){
        this.referenceDivOpenMapObj[patentNumber]=false;
      }
    }
    else{
      // expand all
      for(let patentNumber in this.referenceDivOpenMapObj){
        this.referenceDivOpenMapObj[patentNumber]=true;
      }
    }
  }




  deleteKeyword(index:any){
    this.keywordItems.splice(index,1);
  }

  proceedToIndustryAnalysis(){
    this.onFinalNext();
  }

  toggleReferenceDiv(patentNumber:any){
    this.referenceDivOpenMapObj[patentNumber]=!this.referenceDivOpenMapObj[patentNumber];
  }

  regenerateKeywordResults(){
    this.patentReferenceTierMap={};
    this.claimsConsideredMap={};
    this.summaryData=[];
    this.referenceTableMap={};
    this.pasFirstApiCall(true);
    // this.keywordItems=[];
  }
  hanldeKeywordUpdate(index:any, event:any){
    this.keywordItems[index]=event.target.value;
  }
  handleCompanyCheckboxChange(companyObject:any, eventTarget:any){
    if(eventTarget.checked){
      this.companySelectionList.push(companyObject.name);
      this.productSelectionList.push(...companyObject.products.map((product:any)=>product.name));
      // make sure there are no duplicate entries in the product selection list
      this.productSelectionList=[...new Set(this.productSelectionList)];

    }
    else{
      this.companySelectionList=this.companySelectionList.filter((company:any)=>company!==companyObject.name);
      this.productSelectionList=this.productSelectionList.filter((product:any)=>!companyObject.products.map((product:any)=>product.name).includes(product));

    }
  }

  handleProductCheckboxChange(productObject:any,productCompanyObject:any, eventTarget:any){
    if(eventTarget.checked){
      this.productSelectionList.push(productObject.name);
      if(!this.companySelectionList.includes(productCompanyObject.name)){
        this.companySelectionList.push(productCompanyObject.name);
      }
    }
    else{
      this.productSelectionList=this.productSelectionList.filter((product:any)=>product!==productObject.name);
      // check if no product from the company is selected
      if(!this.productSelectionList.some((product:any)=>productCompanyObject.products.map((product:any)=>product.name).includes(product))){
        this.companySelectionList=this.companySelectionList.filter((company:any)=>company!==productCompanyObject.name);
      }
    }
  }

  getCompanyCheckboxChecked(companyObject:any){
    return this.companySelectionList.includes(companyObject.name);
  }

  getProductCheckboxChecked(productObject:any,productCompanyObject:any){
    return this.productSelectionList.includes(productObject.name) && this.companySelectionList.includes(productCompanyObject.name);
  }
    
  proceedToTargetLinks(){
    this.currentStage=1;
    // filter the patent details based on the selected companies and products
    this.patentDetails=this.patentData.map((patent:any)=>{
      return {
        ...patent,
        companies: patent.companies.filter((company:any)=>this.companySelectionList.includes(company.name)).map((company:any)=>{
          return {
            ...company,
            products: company.products.filter((product:any)=>this.productSelectionList.includes(product.name))
          }
        })
      }
    });
    // filter to only those patents that have at least one company or product selected
    this.patentDetails=this.patentDetails.filter((patent:any)=>patent.companies.length>0);
    this.getTargetLinks();
  }

  proceedToClaimChartGeneration(){
    this.currentStage=3;
    // this.currentStage=4
    this.generateClaimChart();
  }



  getTargetLinks(){
    /*
     Endpoint: /infringement-assesment/techinical-documentation
     Request: {"data": list of dictionaries ([{}, {}, {},………..])}
where each dictionary is {"targeted_company": str, "targeted_product": str}
Response:{
    "technical_documentation_links": [
        {
            "targeted_company": "Samsung Healthcare",
            "targeted_product": "Samsung Healthcare Computed Tomography Devices with Photon Counting Detector (PCD) Technology",
            "technical_documentation_links": [
                "https://www.surgicalroboticstechnology.com/news/neurologica-wins-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite/",
                "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite",
                "https://www.neurologica.com/publications/press-releases/samsung-ushers-in-a-new-era-of-diagnostic-solutions-at-rsna-2023",
                "https://www.samsunghealthcare.com/en/about_us/news_center/310",
                "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0",
                "https://news.samsung.com/global/samsungs-push-to-leverage-artificial-intelligence-on-display-at-rsna-2021",
                "https://news.samsung.com/global/neurologica-corp-receives-fda-510k-clearance-for-enhanced-omnitom-elite-with-ultra-high-resolution-pcd-technology",
                "https://samsunghealthcare.com/en/about_us/news_center/185",
                "https://www.massdevice.com/fda-clears-neurologicas-omnitom-elite-with-photon-counting-detector-technology/",
                "https://samsunghealthcare.com/en/rsna2022"
            ]
        },
  }/**
   * 
   */
  if(this.mock){
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        company.products.forEach((product:any) => {
          product.technicalDocumentationLinks=[
            "https://www.surgicalroboticstechnology.com/news/neurologica-wins-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite/",
            "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite",
            "https://www.neurologica.com/publications/press-releases/samsung-ushers-in-a-new-era-of-diagnostic-solutions-at-rsna-2023",
            "https://www.samsunghealthcare.com/en/about_us/news_center/310",
            "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0",
            "https://news.samsung.com/global/samsungs-push-to-leverage-artificial-intelligence-on-display-at-rsna-2021",
            "https://news.samsung.com/global/neurologica-corp-receives-fda-510k-clearance-for-enhanced-omnitom-elite-with-ultra-high-resolution-pcd-technology",
            "https://samsunghealthcare.com/en/about_us/news_center/185",
            "https://www.massdevice.com/fda-clears-neurologicas-omnitom-elite-with-photon-counting-detector-technology/",
            "https://samsunghealthcare.com/en/rsna2022"
          ]
        });
      });
    });
  }
  else {
    let request_body:any=[]
    this.loadingText = 'Fetching technical documentation links, please wait';
    this.isLoading = true;
    console.log(this.patentDetails)
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        company.products.forEach((product:any) => {
          request_body.push({
            targeted_company: company.name,
            targeted_product: product.name
          });
        });
      });
    });
    this.http.post('/infringement-assessment/technical-documentations', {data: request_body}).then(response => {
      let index=0;
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          company.products.forEach((product:any) => {
            product.technicalDocumentationLinks=response.technical_documentation_links[index++].technical_documentation_links;
          });
        });
      });
      console.log('Technical documentation links:', this.patentDetails);
      this.isLoading = false;
      this.currentStage=3;
    }).catch(error => {
      console.error('Error fetching technical documentation links:', error);
    });

  }
}

generateClaimChart(){
  /*
  Endpoint: /infringement-assesment/claim-charts
  Request: {"data": list of dictionaries ([{}, {}, {},………..])}
where each dictionary is {"patent_number": str, "targeted_product": str, "technical_documentation_links": list of links (list of strings), "prompt_template_source": str}

Note: The value of "prompt_template_source" should be "file"

  Response: 
    "claim_charts_data": {
        "claim_charts": [
            {
                "patent_number": "US8373135B2",
                "targeted_product": "Samsung Healthcare Computed Tomography Devices with Photon Counting Detector (PCD) Technology",
                "claim": "A counting detector, comprising: sensors to convert radiation quanta into electrical pulses; an evaluation unit, including a number of energy thresholds, to generate, for each of the sensors, a count value for each of the energy thresholds from the electrical pulses, each of the count values representing a number of radiation quanta with an energy above a respective one of the energy thresholds, wherein one of the energy thresholds is arranged directly above a characteristic energy of radiation quanta causing double counting in order to correct double counting; and a correction unit to calculate a corrected count value from the count values of the energy thresholds, the corrected count value including reduced double counting for at least one of the energy thresholds.",
                "data": [
                    {
                        "claim_element": "- A counting detector  ",
                        "analyst_comment": "The claim element 'A counting detector' is explicitly supported by multiple references to the Photon Counting Detector (PCD) technology utilized in the OmniTom Elite CT scanner. These references describe the functionality and capabilities of the PCD, emphasizing its role in capturing CT data and generating spectral images, which aligns directly with the concept of a counting detector.",
                        "references": [
                            {
                                "reference": "Counting DetectorPhoton Counting Detector (PCD)Samsung NeuroLogica\n\n\nProducts > More ProductsPress Resources > Press Release \n\n\nRelated Articles\n\n\nSamsung’s Push To Leverage Artificial Intelligence on Display at RSNA 2021",
                                "source": "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite"
                            },
                            {
                                "reference": "NeuroLogica Corp, a subsidiary of Samsung Electronics Co. Ltd., announced today its state-of-the-art OmniTom Elite has received 510(k) clearance for the addition of Photon Counting Detector (PCD) technology.",
                                "source": "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0"
                            },
                            {
                                "reference": "NeuroLogica delivers the first FDA 510(k) cleared, single-source photon counting computed tomography (CT) scanner with single detector.\n\nOmniTom Elite with PCD can generate spectral CT imagesat multiple energy levels.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field.\n\nA single X-ray source paired with PCD generates multiple sets of CT data acquired at the same time with configurable energy thresholds without any cross talk between images.\n\nPCD provides the ability to capture CT data in multiple energy bands leading to potentially more accurate visualization and segmentation of bone, blood clots, plaque, hemorrhage, and intracranial tumors.\n\nThere is also potential with PCD to lower the dose requirements, and fundamentally change the use of injected contrast.",
                                "source": "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0"
                            },
                            {
                                "reference": "The clinical launch of the OmniTom Elite with PCD, the first US FDA 510(k) cleared single-source photon counting computed tomography scanner with a single detector on a mobile system, will be featured at this year’s meeting.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field, capturing the X-ray photons directly at the detector and converting the energy to electrical signals.",
                                "source": "https://www.neurologica.com/publications/press-releases/samsung-ushers-in-a-new-era-of-diagnostic-solutions-at-rsna-2023"
                            },
                            {
                                "reference": "The world of medical imaging is no longer just black & white.\n\nNeuroLogica Corp, a subsidiary of Samsung Electronics, announced today its state-of-the-art OmniTom Elite has received 510(k) clearance for the addition of Photon Counting Detector (PCD) technology.\n\nNeuroLogica delivers the first FDA 510(k) cleared, single-source photon counting computed tomography (CT) scanner with single detector.\n\nOmniTom Elite with PCD can generate spectral CT images at multiple energy levels.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field.\n\nA single X-ray source paired with PCD generates multiple sets of CT data acquired at the same time with configurable energy thresholds without any cross talk between images.\n\nPCD provides the ability to capture CT data in multiple energy bands leading to potentially more accurate visualization and segmentation of bone, blood clots, plaque, hemorrhage and intracranial tumors.\n\nThere is also potential with PCD to lower the dose requirements, and fundamentally change the use of injected contrast.",
                                "source": "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite"
                            },
                            {
                                "reference": "NeuroLogica Corp, a subsidiary of Samsung Electronics, announced its latest configuration of the mobile computed tomography (CT) OmniTom® Elite with Photon Counting Detector (PCD) technology has received U.S. Food and Drug Administration (FDA) 510(k) clearance.\n\nThis advancement builds upon the existing PCD capabilities with groundbreaking enhancements, further solidifying OmniTom® Elite’s position at the forefront of mobile CT imaging technology.\n\nThe newly cleared features optimized for PCD include several significant innovations:\n \n\nUltra-High-Resolution Mode: This development promises unprecedented clarity and detail in CT imaging.\n\nThe addition of an ultra-high-resolution mode now offers an impressive 0.141 mm resolution.",
                                "source": "https://news.samsung.com/global/neurologica-corp-receives-fda-510k-clearance-for-enhanced-omnitom-elite-with-ultra-high-resolution-pcd-technology"
                            }
                        ]
                    },
                ],
                "score": 9
            },
            
        ],
        "patent_infringement_score": {"US8373135B2": 9}
    }
}

*/
 if(this.mock){
  this.patentDetails.forEach(patentInfo => {
    patentInfo.companies.forEach((company:any) => {
      company.products.forEach((product:any) => {
        product.claimChart={
          "patent_number": "US8373135B2",
          "targeted_product": "Samsung Healthcare Computed Tomography Devices with Photon Counting Detector (PCD) Technology",
          "claim": "A counting detector, comprising: sensors to convert radiation quanta into electrical pulses; an evaluation unit, including a number of energy thresholds, to generate, for each of the sensors, a count value for each of the energy thresholds from the electrical pulses, each of the count values representing a number of radiation quanta with an energy above a respective one of the energy thresholds, wherein one of the energy thresholds is arranged directly above a characteristic energy of radiation quanta causing double counting in order to correct double counting; and a correction unit to calculate a corrected count value from the count values of the energy thresholds, the corrected count value including reduced double counting for at least one of the energy thresholds.",
          "data": [
              {
                  "claim_element": "- A counting detector  ",
                  "analyst_comment": "The claim element 'A counting detector' is explicitly supported by multiple references to the Photon Counting Detector (PCD) technology utilized in the OmniTom Elite CT scanner. These references describe the functionality and capabilities of the PCD, emphasizing its role in capturing CT data and generating spectral images, which aligns directly with the concept of a counting detector.",
                  "references": [
                      {
                          "reference": "Counting DetectorPhoton Counting Detector (PCD)Samsung NeuroLogica\n\n\nProducts > More ProductsPress Resources > Press Release \n\n\nRelated Articles\n\n\nSamsung’s Push To Leverage Artificial Intelligence on Display at RSNA 2021",
                          "source": "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite"
                      },
                      {
                          "reference": "NeuroLogica Corp, a subsidiary of Samsung Electronics Co. Ltd., announced today its state-of-the-art OmniTom Elite has received 510(k) clearance for the addition of Photon Counting Detector (PCD) technology.",
                          "source": "https://www.neurologica.com/publications/press-releases/ne"
                      },
                    ]
                },
            ],
            "score": 9
        }
      });
    });
    patentInfo.patentInfringementScore={"US8373135B2": 9}
  });
}
else {
  const requestBody:any=[]
  this.patentDetails.forEach(patentInfo => {
    patentInfo.companies.forEach((company:any) => {
      company.products.forEach((product:any) => {
        requestBody.push({
          patent_number: patentInfo.patentNumber,
          targeted_product: product.name,
          technical_documentation_links: product.technicalDocumentationLinks,
          prompt_template_source: 'file'
        });
      });
    });
  });
  this.loadingText = 'Generating claim charts, please wait';
  this.isLoading = true;
  this.http.post('/infringement-assessment/claim-charts', {data: requestBody}).then(response => {
   this.claimChartData=response.claim_charts_data.claim_charts;
   this.patentInfringementScoreData=response.claim_charts_data.patent_infringement_score;
    this.isLoading = false;
    this.currentStage=4;
  }).catch(error => {
    console.error('Error generating claim charts:', error);
  }
  );
}
}

  hanldeInputLinkUpdate(company:any, product:any)
  {
    const dialogRef = this.dialog.open(LinkInputPopupComponent, {
      width: '300px',
      data: { inputValue: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('Value received from popup:', result);
        if(!product.technicalDocumentationLinks){
          product.technicalDocumentationLinks=[];
        }
        product.technicalDocumentationLinks.push(result);
        alert(product.technicalDocumentationLinks.length)
      }
    });
  }

  handleFileLinkUpdate(company:any, patent:any){
    const dialogRef = this.dialog.open(FileUploadPopupComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('File received from popup:', result);
        this.uploadFileLinkUpdate(result, company, patent);
      }
    });
  
  }

  openLinksDialog(product:any)
  {
    const dialogRef = this.dialog.open(LinksDialogComponent, {
      width: '600px',
      data: { links: product.technicalDocumentationLinks }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('Value received from popup:', result);
        product.technicalDocumentationLinks=result;
      }
    });
  }
  

  uploadFileLinkUpdate(file:any, company:any, product:any){
    console.log(file)
    let formData=new FormData();
    formData.append('file', file);
    this.loadingText = 'Uploading file, please wait';
    this.isLoading = true;
    this.http.postFormData('//infringement-assessment/upload-user-technical-documentation', formData).then(response => {
      console.log(response)
      if(!product.technicalDocumentationLinks){
        product.technicalDocumentationLinks=[];
      }
      product.technicalDocumentationLinks.push(response.user_technical_documentation_link);
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      console.error('Error uploading file:', error);
    });
  }

  startTargetScouting(): void {
    this.isLoading = true;
    this.loadingText = 'Retrieving Target Companies, please wait';
    if(this.mock){
      setTimeout(() => {
        this.getTargetCompanies();
      }, 0);
    }
    else{

      this.getTargetCompanies();
    }
  }

  getTargetCompanies(): void {
    if (this.mock) {
      // Mock response for target companies
      this.patentDetails = this.patentData.map((patent:any) => ({
        ...patent,
        companies: [
          {
            name: 'Alpha Corp.',
            products: []
          },
          {
            name: 'Beta Inc.',
            products: []
          }
        ]
      }));
      this.getCompanyInformation();
    } else {
      console.log(this.patentData)
      const requests = this.patentData.map((patent:any) =>
        this.http.post('/targetCompanies', { patentNumber: patent.patentNumber })
      );

      Promise.all(requests).then(responses => {
        this.patentDetails = responses.map((res: any, index: number) => ({
          // patentNumber: this.patentData[index].patentNumber,
          companies: res.targetCompanies.map((company: string) => ({ name: company, products: [] })),
          ...this.patentData[index]
        }));
      }).catch(error => {
        console.error('Error fetching target companies:', error);
      });
      this.getCompanyInformation();
    }
  }

  getCompanyInformation(){
    this.isLoading = true;
    this.loadingText = 'Retrieving Company Information, please wait';
     setTimeout(() => {
      this.getCompanyInfo();
    }, 2000);
  }

  getCompanyInfo(): void {
  if(this.mock)
  {
    /*"CompanyInformation": {

    "Global Headquarters": {

      "response": "",

      "sourceLink": ""

    },

    "US Headquarters": {

      "response": "",

      "sourceLink": ““

    },

    "State of Incorporation": {

      "response": "",

      "sourceLink": ""

    },

    "Revenue": {

      "response": "",

      "sourceLink": ""

    }

  }*/
//  this is the mock response for company information
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        console.log(patentInfo)
        company.companyInfo = {
          "Global Headquarters": {

            "response": "New York, NY",

            "sourceLink": "N/A"

          },

          "US Headquarters": {

            "response": " New York, NY",

            "sourceLink": "N/A"

          },

          "State of Incorporation": {

            "response": " Delaware",

            "sourceLink": "N/A"

          },

          "Revenue": {

            "response": "Revenue: $50-60 million USD",

            "sourceLink": "N/A"

          }
        };
      });
    });
    this.isLoading = false;
    this.currentStage = 2;
  }
  else {
    const requests = this.patentDetails.flatMap(patentInfo =>
      patentInfo.companies.map((company: any) =>
        this.http.post('/extractCompanyInformation', {
          patentNumber: patentInfo.patentNumber,
          companyName: company.name,
          modelName: 'perplexity-llama-3.1-sonar'
        })
      )
    );

    Promise.all(requests).then(responses => {
      console.log('response to api')
      let index = 0;
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company: any) => {
          console.log(responses[index].CompanyInformation)
          company.companyInfo = responses[index++].CompanyInformation;
        });
      });
    }).finally(()=>{
      this.isLoading = false;
      console.log('post api')
      this.currentStage = 2;
    })
    .catch(error => {
      console.error('Error fetching company information:', error);
      // this.isLoading = false;
    });
  }

  }

  getNewCompanyInfo(){
    console.log(this.patentDetails)
    let companyList:any=[]
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        if(company.new){
          companyList.push({patentNumber:patentInfo.patentNumber, companyName:company.name});
        }
      });
    });
    console.log(companyList)
  //  this would consist a list of patent number and company name. use the same logic but update on the same patent number and company name. this function would be making the api call. company list structure {patentNumber, companyName}
  this.isLoading = true;  
  this.loadingText = 'Retrieving Company Information, please wait';
  if(this.mock){
    // based on response, update the new companies. all new companies have new in their object.
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        if(company.new){
          company.companyInfo = {
            "Global Headquarters": {

              "response": "New York, NY",

              "sourceLink": "N/A"

            },

            "US Headquarters": {

              "response": " New York, NY",

              "sourceLink": "N/A"

            },

            "State of Incorporation": {

              "response": " Delaware",

              "sourceLink": "N/A"

            },

            "Revenue": {

              "response": "Revenue: $50-60 million USD",

              "sourceLink": "N/A"

            }
          };
          company.new=false
        }
      });
    });
    this.isLoading = false;
  }
  else 
  {
    const requests = companyList.map((company:any) =>
      this.http.post('/extractCompanyInformation', {
        patentNumber: company.patentNumber,
        companyName: company.companyName,
        modelName: 'perplexity-llama-3.1-sonar'
      })
    );

    // only update the company info for the company that was updated, match on the basis of patent number as well 
    Promise.all(requests).then(responses => {
      let index = 0;
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company: any) => {
          console.log(company, company.new)
          if(company.new){
            company.companyInfo = responses[index++].CompanyInformation;
          }
          company.new=false
        });

      });
      this.isLoading = false;
    }).catch(error => {
      console.error('Error fetching company information:', error);
      this.isLoading = false;
    });

  }

  }



  proceedToTargetProducts(): void {
    this.isLoading = true;
    this.loadingText = 'Retrieving Target Products, please wait';
    setTimeout(() => {
      this.getTargetProducts();
    }, 2000);
  }

  getTargetProducts(): void {
    if (this.mock) {
      // Mock response for target products
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          company.products = [
            { name: 'Product A' },
            { name: 'Product B' }
          ];
        });
      });
      this.isLoading = false;
      this.currentStage = 3;
    } else {
      const requests = this.patentDetails.flatMap(patentInfo =>
        patentInfo.companies.map((company: any) =>
          this.http.post('/productInformation', {
            patentNumber: patentInfo.patentNumber,
            companyName: company?.name,
            modelName: 'perplexity-llama-3.1-sonar'
          })
        )
      );

      Promise.all(requests).then(responses => {
        let index = 0;
        this.patentDetails.forEach(patentInfo => {
          patentInfo.companies.forEach((company: any) => {
            company.products = responses[index++].ProductInformation['Targeted products'].map((product: any) => ({ name: product.response }));
          });
        });
      }).finally(()=>{
        this.isLoading = false;
        this.currentStage = 3;
      }).catch(error => {
        console.error('Error fetching target products:', error);
        this.isLoading = false;
      });
    }
  }

  proceedToRevenueIdentification(): void {
    this.isLoading = true;
    this.loadingText = 'Retrieving Revenue Details, please wait';
    setTimeout(() => {
      this.getRevenueDetails();
      this.titleText = 'Revenue Identification';
    }, 2000);
  }

  getRevenueDetails(): void {
    if (this.mock) {
      // Mock response for revenue details
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          company.revenue = [
            {
              response: ' $50-60 million USD',
              sourceLink: 'N/A'
            }
          ];
          company.products.forEach((product: any) => {
            product.revenue = ' $5-10 million USD';
          });
        });
      });
      this.isLoading = false;
      this.currentStage = 4;
    } else {
      const requests = this.patentDetails.flatMap(patentInfo =>
        patentInfo.companies.map((company: any) =>
          this.http.post('/revenueInformation', {
            patentNumber: patentInfo.patentNumber,
            companyName: company.name,
            productList: company.products.map((product: any) => product.name),
            modelName: 'perplexity-llama-3.1-sonar'
          })
        )
      );

      Promise.all(requests).then(responses => {
        let index = 0;
        this.patentDetails.forEach(patentInfo => {
          patentInfo.companies.forEach((company: any) => {
            company.products.forEach((product: any) => {
              /*{

  "RevenueInformation":[ {

        "Verizon Media Smartplay Prebid": {

          "response": "Information not available",

          "sourceLink": "Information not available"

            }},{

        "Verizon Media DSP": {

          "response": "Information not available",

          "sourceLink": "Information not available"}

            }},{

        "Next-Gen Solutions": {

          "response": "Information not available",

          "sourceLink": "Information not available"

            }}

      }

]
}
  }*/
              // map the product revenue by matching the product name
              console.log(responses[index], product)
             responses[index].RevenueInformation["Product Revenue"].forEach((revenue:any) => {
              if(Object.keys(revenue)[0] === product.name){
                product.revenue = revenue[product.name]
                console.log(product)
              }
            });
          });
            index++;
        });
      })
    }).finally(()=>{
      this.isLoading = false;
      this.currentStage = 4;
    }).catch(error => {
        console.error('Error fetching revenue details:', error);
        this.isLoading = false;
      });
    }
  }

  toggleEditCompanies(): void {
    this.isEditingCompanies = !this.isEditingCompanies;
    if(this.isEditingCompanies){
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          company.new = false;
        });
      });
    }
    else {
      this.getNewCompanyInfo();
    }
  }

  handleCompanyChange(event:any, company:any)
  {
    console.log(event, company)
    company.new=true;
  }

  addCompany(patent: any): void {
    patent.companies.push({ name: '', products: [], new:true });
  }

  confirmEditCompany(): void {
    this.isEditingCompanies = false;
    this.getNewCompanyInfo();
  }

  toggleEditProducts(): void {
    this.isEditingProducts = !this.isEditingProducts;
  }

  addProduct(company: any): void {
    company.products.push({ name: '' });
  }

  confirmEditProduct(): void {
    this.isEditingProducts = false;
  }
  deleteCompany(patent: any, companyIndex: number): void {
    patent.companies.splice(companyIndex, 1);
  }
  deleteProduct(company: any, productIndex: number): void {
    company.products.splice(productIndex, 1);
  }
  saveCompanies(): void {
    this.isEditingCompanies = false;
  }
  saveProducts(): void {
    this.isEditingProducts = false;
  }

  handlePopupSubmit(value: string): void {
    console.log('Value received from popup:', value);
  }
  openPopup(patentNumber:any, productName:any, companyName:any): void {
    const dialogRef = this.dialog.open(LinkInputPopupComponent, {
      width: '300px',
      data: { inputValue: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('Value received from popup:', result);
        this.handleInputPopup(result, patentNumber, productName, companyName);
      }
    });
  }

  assistMode=false;

  toggleAssistMode(){
    this.assistMode=!this.assistMode
  }

  handleInputPopup(value: string, patentNumber:any, productName:any, companyName:any): void {
    /*{

  "url": "https://en.wikipedia.org/wiki/Verizon",

  "patentNumber": "US6421675B1",

  "productName": "",

  "companyName": "Verizon Media Inc."

}

Response:

{

  "revenueInformationURLModel": {

    "response": "245.1 - 245.1 billion",

    "sourceLink": "https://www.microsoft.com/en-us/investor/earnings/fy-2024-q4/press-release-webcast"

  }*/
 // make this api call and update the revenue information for the product. if product is "", then you need to update the revenue information of the company
  this.isLoading = true;
  this.loadingText = 'Retrieving Revenue Details, please wait';
  this.http.post('/revenueURLInformation', {
    url: value,
    patentNumber: patentNumber,
    productName: productName,
    companyName: companyName
  }).then(response => {
    console.log(response, response.revenueInformationURLModel)
    if(productName === ""){
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          if(company.name === companyName){
            company.revenue = [
              {
                response: response.revenueInformationURLModel.response,
                sourceLink: response.revenueInformationURLModel.sourceLink
              }
            ];
          }
        });
      });
    }
    else{
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          if(company.name === companyName){
            company.products.forEach((product:any) => {
              if(product.name === productName){
                product.revenue = response.revenueInformationURLModel;
                console.log('updating product revenue:', product.revenue, response.revenueInformationURLModel.response);
                console.log(product)
              }
            });
          }
        });
      });
    }
    this.isLoading = false;
  }).catch(error => {
    console.error('Error fetching revenue details:', error);
    this.isLoading = false;
  });
  }


  openFileUploadPopup(patentNumber:any, productName:any, companyName:any): void {
    const dialogRef = this.dialog.open(FileUploadPopupComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('File received from popup:', result);
        this.handleProductRevenueFileUpload(result, patentNumber, productName, companyName);
      }
    });
  
}

  handleProductRevenueFileUpload(file:any, patentNumber:any, productName:any, companyName:any ){
    /*
    Endpoint: /revenuePDFInformation

Resquest: 

Body:

File

Parameters:

patentNumber

productName

companyName

Response:

{

  "revenueInformationPDFModel": {

    "response": "168,088 - 211,915 million",

    "sourceLink": "https://storage.googleapis.com/infringement_detector/revenue%20information/0000950170-23-035122.pdf"

  }

}*/
// make this api call and update the revenue information for the product. if product is "", then you need to update the revenue information of the company
this.isLoading = true;
this.loadingText = 'Retrieving Revenue Details, please wait';
// 
const formData=new FormData();
formData.append('file', file);
this.http.postFormData('/revenuePDFInformation?patentNumber',  formData, {
  params: {patentNumber: patentNumber, productName: productName, companyName: companyName}
}).then(response => {
  if(productName === ""){
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        console.log(company, companyName)
        if(company.name === companyName){
          company.companyInfo.Revenue = {
              response: response.revenueInformationPDFModel.response,
              sourceLink: response.revenueInformationPDFModel.sourceLink
            }
        }
      });
    });
  }
  else{
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        if(company.name === companyName){
          company.products.forEach((product:any) => {
            console.log(product, productName)
            if(product.name === productName){
              product.revenue = response.revenueInformationPDFModel;
            }
          });
        }
      });
    });
  }
    this.isLoading = false;
})
  .catch(error => {
    console.error('Error fetching revenue details:', error);
    this.isLoading = false;
  });
  }

  showRevenueControls(company:any){
    if(company.showRevenue){

      company.showRevenue=false;
    }
    else{
      company.showRevenue=true;
    }
  }

  showProductRevenueControls(product:any){
    if(product.showRevenue){

      product.showRevenue=false;
    }
    else{
      product.showRevenue=true;
    }
  }
}
